import * as React from 'react';
import { TextInput } from 'react-native';

export function TraxxTextInput(props: any) {
  return <TextInput {...props} style={[{ fontFamily: 'PoppinsRegular', fontSize: 14 }, props.style]} />;
}
